
function User() {
    // Integer
    const eventsPlayed = 0;

    // Arrays
    const unlockedSegments = [];
    const storiesCompleted = [];
    const talentRequestTypesCompleted = [];
    const unlockedPowerups = [];
    const unlockedCharacters = [];

    // Objects
    const unlockedCombinations = {};
    const settings = {};

    // Strings
    const updateVersionShown = null;

    return {
        eventsPlayed,
        unlockedSegments,
        storiesCompleted,
        talentRequestTypesCompleted,
        unlockedCombinations,
        settings,
        unlockedPowerups,
        unlockedCharacters,
        updateVersionShown
    };
}

export { User };